import axios from 'axios'
import { getConfig } from 'src/helpers'
import { customHeadersTDC } from './http.interceptors'

const config = getConfig()

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    'x-business-unit': config.businessUnit,
    'x-origin': 'catalogo',
  },
})

axiosInstance.interceptors.request.use(customHeadersTDC, (error) => Promise.reject(error))

export const Api = axiosInstance

export const VD_CUSTOMER_BFF_URL = process.env.REACT_APP_VD_CUSTOMER_BFF_URL
